import { swapApi } from "@assets/api";

export const postTimeStamp = async () => {
  try {
    const response = await swapApi.post("/time_stamp");
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
